var _path, _polygon, _path2, _ellipse, _polygon2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _circle, _path3, _path4, _path5, _path6, _path7, _polygon3, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _polygon4, _path15, _path16, _polygon5, _path17, _rect10, _path18, _polygon6, _path19, _path20, _path21, _path22, _rect11, _path23, _path24, _path25, _path26, _polygon7, _polygon8, _polygon9, _path27, _polygon10, _path28, _path29, _path30, _path31, _circle2, _path32, _path33;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeamPresentation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 300",
    "data-imageid": "team-presentation-two-color-df5c5",
    imageName: "Team presentation",
    className: "illustrations_image",
    style: {
      width: 183
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "#124_team presentation_twocolour") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M106.27,55.84s-5.94-5-10.6-1.51S94.17,72,84,68.76c0,0,11,9.16,18.77-5.8Z",
    fill: "#24285b"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "268.53 92.48 268.53 110.85 280.4 110.85 282.99 118.16 286.06 110.85 297.93 110.85 297.93 92.48 268.53 92.48",
    fill: "#e6e6e6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M281.75,105.77h0a.91.91,0,0,1-.69-.36l-3.1-4a.92.92,0,0,1,1.45-1.13l2.44,3.14,6-6.5a.92.92,0,1,1,1.34,1.25l-6.75,7.29A.91.91,0,0,1,281.75,105.77Z",
    opacity: 0.12
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 201.67,
    cy: 256.34,
    rx: 165.67,
    ry: 14.58,
    fill: "#e6e6e6",
    opacity: 0.45
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "178.46 253.72 174.17 250.53 192.91 225.31 192.91 181.88 198.25 181.88 198.25 227.08 178.46 253.72",
    fill: "#a5a5a5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 201.73,
    y: 221.49,
    width: 5.34,
    height: 33.86,
    transform: "translate(-100.88 164.77) rotate(-35.83)",
    fill: "#a5a5a5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 149.39,
    y: 52.84,
    width: 92.39,
    height: 130.65,
    fill: "#e6e6e6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 149.39,
    y: 175.77,
    width: 92.39,
    height: 17.56,
    fill: "#c9c9c9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 174.23,
    y: 139.39,
    width: 42.7,
    height: 9.02,
    fill: "#a5a5a5",
    opacity: 0.39
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 174.23,
    y: 154.27,
    width: 42.7,
    height: 9.02,
    fill: "#a5a5a5",
    opacity: 0.13
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 218.29,
    y: 38.39,
    width: 48.76,
    height: 31.07,
    fill: "#ffd200"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 227.91,
    y: 56.56,
    width: 6.61,
    height: 6.61,
    fill: "#24285b"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 239.05,
    y: 49.45,
    width: 6.61,
    height: 13.72,
    fill: "#24285b"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 250.81,
    y: 44.67,
    width: 6.61,
    height: 18.5,
    fill: "#24285b"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 195.58,
    cy: 100.45,
    r: 24.81,
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M179.56,108.86s3.52-2.13,3.27,5.31,11.11,57.66-33.44,58.5V155.42l17.28-13.2,7.56-18.89Z",
    opacity: 0.08
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M101.53,65.57s-4-.57-2.36-6.07,6.23-5.3,7.53-3.86Z",
    fill: "#fad347",
    className: "target-color"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M195.58,75.64v24.81l24.29-5.06S216.48,75.47,195.58,75.64Z",
    fill: "#ffd200"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M195.58,100.45l-13.79,20.62s13.9,10.58,30-1.86c0,0,11-8,8.07-23.82Z",
    fill: "#24285b"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M113.59,62.59a30,30,0,0,1-1.89,7.76,2.41,2.41,0,0,1-3.22,1.16,5.37,5.37,0,0,1-3.35-4.73l-.61-4.4a4.3,4.3,0,0,1,2.74-4.17C110.29,56.8,114,59.69,113.59,62.59Z",
    fill: "#f4a28c"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "103.53 64.83 100.4 80.28 109.03 81.4 107.87 70 103.53 64.83",
    fill: "#f4a28c"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M113.12,65.59l1,2.07a.78.78,0,0,1-.7,1.1h-1.87Z",
    fill: "#f4a28c"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M107.91,70.32a5.81,5.81,0,0,1-2.64-1.71s-1,3.31,3,5Z",
    fill: "#ce8172",
    opacity: 0.31
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M103.85,64.91s.31-1.83-1.08-1.95-1.86,2.51,0,3.11Z",
    fill: "#f4a28c"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M112.64,62.18a13.86,13.86,0,0,1-4.59-.53s-1.58,5.2-5.94,6.05c0,0-3.09-8.38,2.16-10.89,4.39-2.11,7.7-4,10.73-.6A3.6,3.6,0,0,1,112.64,62.18Z",
    fill: "#24285b"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M119.89,127.83s.28,33.24,22.78,35.45S178.33,121,178.33,121s3.84-4.5,0-7.5c0,0,2.67-7,.34-7.33s-5.34,12-5.34,12-13.06,23-23.94,24.73-1.9-34.06-26.39-51.56S119.89,127.83,119.89,127.83Z",
    fill: "#f4a28c"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M107.82,64.45s0-2.15-1.71-2-2,2.63,0,3.85Z",
    fill: "#f4a28c"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M100.4,80.28,109,81.4s46.75,22.43,20,54a17.79,17.79,0,0,0-4.17,9.3l-2.42,19.41H87.32S36.61,91.62,100.4,80.28Z",
    fill: "#fad347",
    className: "target-color"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "125.16 191.2 126.22 248.71 122.5 249.8 110.64 195.45 125.16 191.2",
    fill: "#f4a28c"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M100.65,98.24s9.82,14.89-3.64,29S91.36,153.6,106.7,144s17.82,2.92,17.82,2.92l-.91,7.9-23.88-.26-26.46.1L64,132.54Z",
    opacity: 0.08
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M126.12,247.87s2.26,2.66,5,2.42,3.31,3.66-1.15,3.42a25,25,0,0,1-4.12-.56,7.37,7.37,0,0,0-3.75.27,1.19,1.19,0,0,1-1.28-.46c-1.32-1.43,1.66-5,1.66-5Z",
    fill: "#fad347",
    className: "target-color"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "77.21 191.08 73.27 248.47 76.93 249.74 91.5 196.05 77.21 191.08",
    fill: "#f4a28c"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4,247.63s-2.39,2.54-5.13,2.17-3.49,3.48,1,3.46a24.45,24.45,0,0,0,4.14-.34,7.23,7.23,0,0,1,3.73.45,1.18,1.18,0,0,0,1.3-.39c1.39-1.37-1.4-5-1.4-5Z",
    fill: "#fad347",
    className: "target-color"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 107.74,
    y: 109.23,
    width: 27.12,
    height: 35.99,
    transform: "translate(50.26 -33.56) rotate(19.8)",
    fill: "#ffd200"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M122.55,135.69s8.25,1.84,5.42,13.06l-14.23-5Z",
    opacity: 0.08
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "123.61 154.78 133.4 213.88 107.82 213.88 97.02 213.88 66.05 214.55 79.56 154.78 123.61 154.78",
    fill: "#24285b"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M100.65,98.24c.54-10.36-11.5-16.53-19.9-10.44C69.38,96,53.27,110,57.67,146.33c5.33,44.06,60.57-1.6,60.57-1.6L116,138.91s-30.36,19-38.51,7.09c-2.51-3.67.92-9.21,3.51-13.61C85.63,124.45,100,110.9,100.65,98.24Z",
    fill: "#f4a28c"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M116,138.91s2.27-5.94,6.07-4.62,1.06,9.22-3.79,9.66Z",
    fill: "#f4a28c"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M97,81s-1.19-3.73,5.7-4.51,12.39,2.15,10.13,7C112.84,83.48,107.64,87.62,97,81Z",
    fill: "#fad347",
    className: "target-color"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M97,81s-1.19-3.73,5.7-4.51,12.39,2.15,10.13,7C112.84,83.48,107.64,87.62,97,81Z",
    fill: "#fff",
    opacity: 0.46
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 114.12,
    y: 138.54,
    width: 4.58,
    height: 8.7,
    transform: "translate(-63.96 105) rotate(-38.97)",
    fill: "#24285b"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M277.12,253.29s4.53,5.42,7.86,4.33-2.57-8.3-2.57-8.3Z",
    fill: "#fad347",
    className: "target-color"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M298,253.29s-4.53,5.42-7.86,4.33,2.57-8.3,2.57-8.3Z",
    fill: "#fad347",
    className: "target-color"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M278.78,156.87s-39.8-3.35-43.58,14.69c-2.48,11.82-4,33.86-4.79,47.67A12.63,12.63,0,0,0,242,232.51l42.25,3.5L327,232.47a14.4,14.4,0,0,0,12.83-11.14C345.16,198.37,350,145.89,278.78,156.87Z",
    fill: "#fad347",
    className: "target-color"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M260.37,234.45s-26.09,5.05-20.22,16.4c4.27,8.26,26.4,4.73,38.14,2.19a42.81,42.81,0,0,1,14.93-.53c7.94,1.1,20.51,2.34,30,1,16.72-2.44,4.91-19.75-16-19.75S260.37,234.45,260.37,234.45Z",
    fill: "#24285b"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "268.01 191.35 266.92 181.31 324.08 182 319.56 233.08 305.11 234.05 268.01 191.35",
    opacity: 0.08
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "264.69 228.16 260.37 191.35 311.44 191.35 307.51 228.16 307.94 236.01 264.69 236.01 264.69 228.16",
    fill: "#ffd200"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "261.5 200.97 289.1 236.01 264.69 236.01 264.69 228.16 261.5 200.97",
    opacity: 0.08
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M279.36,134.56a30.86,30.86,0,0,0-2.22,7.88,2.48,2.48,0,0,0,2.3,2.65,5.46,5.46,0,0,0,5.36-2.55l2.77-3.61a4.42,4.42,0,0,0-.35-5.1C285.22,131.05,280.42,131.74,279.36,134.56Z",
    fill: "#f4a28c"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "285.71 138.33 287.54 154.38 278.63 154.76 280.87 142.93 285.71 138.33",
    fill: "#f4a28c"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M278.27,137.47l-1.91,1.36a.79.79,0,0,0,.08,1.33l1.67.94Z",
    fill: "#f4a28c"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M280.27,145.49a5.84,5.84,0,0,0,3-1.59s-.26,2.95-3.63,5.72Z",
    fill: "#ce8172",
    opacity: 0.31
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M280.22,135a7.62,7.62,0,0,0,1,.59,7.72,7.72,0,0,1,1.35.93l.33.28a1.56,1.56,0,0,1,.51,1.66c-.44,1.51-.76,4.43,2.81,5.78,0,0,5.32-4.5,3.57-9.63a10.27,10.27,0,0,0-6.36-6.14C279.47,127.24,276.79,132.68,280.22,135Z",
    fill: "#24285b"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M282.73,141.13a1.22,1.22,0,0,1,.17-1.23c.44-.56,1.21-1.25,2-.88s.61,1.85-.27,2.61a1.23,1.23,0,0,1-1.93-.5Z",
    fill: "#f4a28c"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 285.84,
    cy: 209.46,
    r: 4.21,
    fill: "#fff"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M272.5,156.63s-.79-6.24,16.6-4.77c0,0,5.48.39,4.44,4.77C293.54,156.63,287.5,162.42,272.5,156.63Z",
    fill: "#fad347",
    className: "target-color"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M272.5,156.63s-.79-6.24,16.6-4.77c0,0,5.48.39,4.44,4.77C293.54,156.63,287.5,162.42,272.5,156.63Z",
    fill: "#fff",
    opacity: 0.46
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamPresentation);
export default __webpack_public_path__ + "static/media/team-presentation.56d18481df17347c13c653f2fc0194a7.svg";
export { ForwardRef as ReactComponent };